import { createContext } from "react";
import { UploaderContextValues } from "../../types";

export const UploaderContext = createContext<UploaderContextValues>({
    errorMessages: undefined,
    wasUpdated: false,
    isUploading: false,
    isUpdating: false,
    wasProcessed: false,

    isOpenDialogToConfirmChanges: false,
    hasDataToChange: false,

    columnsToCreate: [],
    columnsToUpdate: [],
    columnsHeadersMap: new Map<string, string>(),
    doorsForDisableOrEnable: [],
    doorsForEnableWithUnits: [],
    doorsForDisableWithUnits: [],
});
